import FilterRegister from "../../../../components/filter/register-basic";
import reqFormaPgto from "../../../../services/reqMultiTenant/reqFormaPgto";
import LibBoolean from "../../../../util/libBool";
import { RegisterProvider } from "../../register-matrix/context-api";
import MainRegisterMatrix from "../../register-matrix/main";
import FormPayment from "../form";

const MainRegisterStore = () => {
	const options = {
		id: "id_forma", //usado para saber qual field usar para atualizar
		ident: "registerFormPayment", //usado para definir os event listners
		identFilter: "filterFormPayment", //usado para definir os event listners
		identReport: "reportFormPayment", //usado para definir os event listners
		title: "Forma Pagamento",
		subTitle: "Cadastro",
		tableColumns: [
			{ key: "nome", label: "Forma de Pagamento", align: "left" },
			{ key: "empty1", label: "", align: "left" },
			{ key: "empty2", label: "", align: "left" },
			{ key: "empty3", label: "", align: "left" },
			{ key: "actions", label: "", align: "right" },
		],
		reportColumns: [
			{ key: "nome", label: "Forma de Pagamento", align: "left" },
			{ key: "ativo", label: "Status (Ativo)", align: "center" },
		],
		hasActive: true,
		parametersFilter: [{ id: 1, label: "Forma Pgto.", value: "nome" }],
	};

	const fetch = async (filterData, newPage, perPage = 15) => {
		const { param, paramValue, active } = filterData; //contem active que retorna true ou false

		const newActive = LibBoolean.strToBoolean(active);

		const response = await reqFormaPgto.listPaginate(param, paramValue, newActive, newPage, perPage);

		return response;
	};

	const fetchID = async (currentId) => {
		const response = await reqFormaPgto.listID(currentId);

		return response;
	};

	const insert = async (data) => {
		const response = await reqFormaPgto.insert(data);

		return response;
	};

	return (
		<RegisterProvider options={options} fetch={fetch} fetchID={fetchID} insert={insert}>
			<MainRegisterMatrix FormComponent={FormPayment} FormFilter={FilterRegister} />
		</RegisterProvider>
	);
};

export default MainRegisterStore;
